var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "data-parameter-group": _vm.parameterGroupIdentifier,
      "data-parameter-key": _vm.parameter.key
    }
  }, [_vm.parameter.inputType === 'text' ? _c('b-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditable
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }) : _vm.parameter.inputType === 'text-area' ? _c('b-form-textarea', {
    attrs: {
      "type": "text",
      "rows": "1",
      "disabled": !_vm.isEditable,
      "max-rows": "32"
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }) : _vm.parameter.inputType === 'boolean_switch' ? _c('b-checkbox', _vm._b({
    attrs: {
      "switch": "",
      "disabled": !_vm.isEditable,
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }, 'b-checkbox', [_vm.$attrs], false), [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm.parameter.inputType === 'select_one' ? _c('b-radio-group', {
    attrs: {
      "disabled": !_vm.isEditable,
      "options": _vm.translateParameterOptions(_vm.parameter),
      "stacked": ""
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }) : _vm.parameter.inputType === 'select_and_sort_multiple' ? _c('div', [_vm.isEditable ? _c('OmniCheckboxes', {
    attrs: {
      "options": _vm.translateParameterOptionsForOmniCheckboxes(_vm.parameter),
      "draggable": "",
      "grid": false
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }) : _c('OmniCheckboxes', {
    attrs: {
      "disabled": !_vm.isEditable,
      "options": _vm.translateParameterOptionsForOmniCheckboxes(_vm.parameter)
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  })], 1) : _vm.parameter.inputType === 'select_multiple' ? _c('OmniCheckboxes', {
    attrs: {
      "disabled": !_vm.isEditable,
      "options": _vm.translateParameterOptionsForOmniCheckboxes(_vm.parameter)
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }) : _vm.parameter.inputType === 'sort_values' ? _c('OmniDraggableList', {
    attrs: {
      "disabled": !_vm.isEditable,
      "options": _vm.translateParameterOptionsForOmniCheckboxes(_vm.parameter)
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }) : _vm.parameter.inputType === 'label_value_pairs' ? _c('label-value-pairs-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "parameter": _vm.parameter
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }) : _vm.parameter.inputType === 'theme' ? _c('theme-picker', {
    attrs: {
      "disabled": !_vm.isEditable,
      "options": _vm.parameter.options
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }) : _vm.parameter.inputType === 'refresh_system_settings_cache' ? _c('RefreshSystemSettingsCacheButton', {
    attrs: {
      "disabled": !_vm.isEditable
    }
  }) : _vm.parameter.inputType === 'refresh_trigger_cache' ? _c('RefreshTriggerCacheButton') : _vm.parameter.inputType === 'unable_to_ship_reasons' ? _c('unable-to-ship-reasons', {
    attrs: {
      "parameter": _vm.parameter,
      "disabled": !_vm.isEditable
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }) : _c('i', {
    staticClass: "text-danger"
  }, [_vm._v("Onbekend input type \"" + _vm._s(_vm.parameter.inputType) + "\"")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }